import { render, staticRenderFns } from "./SimilarListDetails.vue?vue&type=template&id=348fc767&scoped=true&"
import script from "./SimilarListDetails.vue?vue&type=script&lang=ts&"
export * from "./SimilarListDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarListDetails.vue?vue&type=style&index=0&id=348fc767&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348fc767",
  null
  
)

export default component.exports